import { REDUCE_PRODUCT } from '../../constants/actions/product';

export function reduceProduct(payload) {
    return {
        type: REDUCE_PRODUCT,
        payload,
    };
}
